import { render, staticRenderFns } from "./Tvshow.vue?vue&type=template&id=09c46afe&"
import script from "./Tvshow.vue?vue&type=script&lang=js&"
export * from "./Tvshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c46afe')) {
      api.createRecord('09c46afe', component.options)
    } else {
      api.reload('09c46afe', component.options)
    }
    module.hot.accept("./Tvshow.vue?vue&type=template&id=09c46afe&", function () {
      api.rerender('09c46afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/Tvshow.vue"
export default component.exports